import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Bridge from "./components/Bridge";
import Pillars from "./components/Pillars";
import ThreeSteps from "./components/ThreeSteps";
import PortfolioCTA from "./components/PortfolioCTA";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieConsentBanner from "./components/CookieConsentBanner";

const Home = () => {
  useEffect(() => {
    document.title = "Pezente Digital";
  }, []);
  return (
    <div className="min-h-screen bg-[#05080F] text-[#E8EAF0]">
      <Navbar />
      <main>
        <Hero />
        <Bridge />
        <Pillars />
        <ThreeSteps />
        <PortfolioCTA />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieConsentBanner />
      </LanguageProvider>
    </div>
  );
}

export default App;
